<template>
  <div class="pre-translation-detail">

    <!-- <div class="title">{{$t('newProjectV2.transMemoryBank')}}</div>
    <div class="content">
      <el-checkbox @change="handleModel" v-model="isUseMemory">{{$t('newProjectV2.transMemoryBankItem')}}</el-checkbox>
    </div>

    <div class="title">{{$t('newProjectV2.machineTrans')}}</div>
    <div class="content">
      <el-checkbox @change="handleModel" v-model="isPreMt">{{$t('newProjectV2.machineTransItem')}}</el-checkbox>
    </div>

    <div class="title">{{$t('newProjectV2.sentStates')}}</div>
    <div class="content">
      <el-checkbox @change="handleModel" v-model="isAutoCommit">{{$t('newProjectV2.sentStatesItem')}}</el-checkbox>
    </div> -->

    <ul>
      <li>
        <div class="title">{{$t('newProjectV2.transMemoryBank')}}<el-switch @change="handleModel" v-model="isUseMemory" active-color="#0078FC" inactive-color="#DCDCDC"></el-switch></div>
        <div class="content">{{$t('newProjectV2.transMemoryBankItem')}}</div>
      </li>
      <li>
        <div class="title">{{$t('newProjectV2.machineTrans')}}<el-switch @change="handleModel" v-model="isPreMt" active-color="#0078FC" inactive-color="#DCDCDC"></el-switch></div>
        <div class="content">{{$t('newProjectV2.machineTransItem')}}</div>
      </li>
      <li v-if="$route.query.type !== 'homework'">
        <div class="title">{{$t('newProjectV2.sentStates')}}<el-switch @change="handleModel" v-model="isAutoCommit" active-color="#0078FC" inactive-color="#DCDCDC"></el-switch></div>
        <div class="content">{{$t('newProjectV2.sentStatesItem')}}</div>
      </li>
      <li v-if="$route.query.type !== 'homework'">
        <div class="title">{{$t('newProjectV2.lockRepeat')}}<el-switch @change="handleModel" v-model="ifRepeatLock" active-color="#0078FC" inactive-color="#DCDCDC" disabled></el-switch></div>
        <div class="content">{{$t('newProjectV2.filelockRepeat')}}</div>
      </li>
    </ul>

  </div>
</template>

<script>
export default {
  name: 'PreTranslationDetail',
  props: {
    preTransList: {
      type: Object,
      require: true,
    }
  },
  data () {
    return {
      isUseMemory: this.preTransList.isUseMemory,            // 用翻译记忆库进行预翻译
      isPreMt: this.preTransList.isPreMt,                    // 用机器翻译进行预翻译
      isAutoCommit: this.preTransList.isAutoCommit,          // 100%翻译记忆库匹配
      ifRepeatLock:this.preTransList.ifRepeatLock               //锁定重复语段
    }
  },
  methods: {
    handleModel (index) {
      // switch (index) {
      //   case 1:
      //     this.isUseMemory = !this.isUseMemory;
      //     break;
      //   case 2:
      //     this.isPreMt = !this.isPreMt;
      //     break;
      //   case 3:
      //     this.isAutoCommit = !this.isAutoCommit;
      //     break;
      // }
      this.$emit('preTransListChange', {
        isUseMemory: this.isUseMemory,
        isPreMt: this.isPreMt,
        isAutoCommit: this.isAutoCommit
      });
    }
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>